"use client";

import createIcon from './util/createIcon';
export default createIcon('M18,2H6L2,8L12,22L22,8L18,2M4.43,8L7.07,4H16.93L19.57,8L12,18.56L4.43,8Z', 'DiamondOutline');